const listElements = document.querySelectorAll(".expanded-list__element");

if (listElements) {
  listElements.forEach((element) => {
    element.addEventListener("click", () => {
      element.classList.toggle("expanded-list__element--active");
    });
  });
}
